import { render, staticRenderFns } from "./CustomerJobList.vue?vue&type=template&id=0fdfd66e&"
import script from "./CustomerJobList.vue?vue&type=script&lang=js&"
export * from "./CustomerJobList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports